import { motion } from 'motion/react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function ShortTextInput({ question, value, onChange, onSubmit }: AnswerInputProps<string>) {
  const maxLength = question.settings.maxLength
  const readOnly = question.settings.readOnly === true
  const inputType =
    question.type === 'EMAIL' ? 'email' : question.type === 'WEBSITE' ? 'url' : 'text'
  const pattern = getValidationPattern(question)

  return (
    <div className="flex flex-col gap-2">
      <input
        type={inputType}
        value={value ?? ''}
        maxLength={maxLength}
        pattern={pattern}
        readOnly={readOnly}
        aria-readonly={readOnly || undefined}
        placeholder={question.settings.placeholder ?? '請輸入答案'}
        onChange={(event) => {
          if (!readOnly) onChange(event.target.value)
        }}
        onKeyDown={(event) => {
          if (!readOnly && event.key === 'Enter') onSubmit()
        }}
        className="w-full border-0 border-b-2 border-slate-300 bg-transparent px-0 py-3 text-xl outline-none transition-colors focus:border-[var(--form-accent,#6366F1)] read-only:cursor-not-allowed read-only:opacity-80"
        style={{
          borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 34%, transparent)',
          color: 'var(--form-answer,#334155)',
          fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          fontSize: 'var(--form-input-size,1.25rem)',
          lineHeight: 'var(--form-line-height,1.55)',
        }}
      />
      <motion.div
        layout
        className="h-0.5 bg-[var(--form-accent,#6366F1)]"
        initial={{ width: 0 }}
        animate={{ width: value ? '100%' : '0%' }}
      />
      {maxLength && (
        <div
          className="text-right"
          style={{
            color: 'var(--form-answer,#64748B)',
            fontSize: 'var(--form-meta-size,0.9375rem)',
          }}
        >
          {value?.length ?? 0} / {maxLength}
        </div>
      )}
      {question.settings.errorMessage ? (
        <div className="text-sm text-rose-500">{question.settings.errorMessage}</div>
      ) : null}
      {readOnly && typeof question.settings.readOnlyReason === 'string' ? (
        <div className="text-sm text-slate-500">{question.settings.readOnlyReason}</div>
      ) : null}
    </div>
  )
}

function getValidationPattern(question: AnswerInputProps<string>['question']) {
  if (typeof question.settings.validationRegex === 'string')
    return question.settings.validationRegex
  if (question.type === 'EMAIL') return '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$'
  if (question.type === 'WEBSITE') return '^https?://.+\\..+'
  return undefined
}
